module.exports = __webpack_public_path__ + "img/2.f3c307db.png";